import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    document.documentElement.scrollIntoView({ behavior: 'auto' });

    document.body.scrollTop = 0;

    document.documentElement.scrollTop = 0;
  }, [pathname]);

  return null;
};
